import {combineReducers} from 'redux';
import {
  ACCESSIBILITY,
  BILLING,
  CANCEL_SERVICE,
  CONSENT,
  CONTACT_CDV,
  CONTACT_HSD,
  CONTACT_OTHER,
  CONTACT_VID,
  CONTACT_XH,
  DEVICE_SWAP_INTERNET,
  DEVICE_SWAP_REWARDS,
  DEVICE_SWAP_VIDEO_COMBO,
  MODIFY_SERVICE,
  NPS_FALLOUT_CDV,
  NPS_FALLOUT_VID_HSD_X1,
  NPS_FALLOUT_XH,
  OOFOOTPRINT,
  PROACTIVE_REPAIR_INGRESS,
  RETENTION,
  RETENTION_HSD_IE,
  TROUBLESHOOT_CDV,
  TROUBLESHOOT_HSD,
  TROUBLESHOOT_VID,
  WEAREONIT,
} from 'src/shared/constants/scheduleCallbackIntents';
import {
  SET_DAY,
  SET_EMAIL,
  SET_FLOW,
  SET_INTENT,
  SET_PHONE,
  SET_TIMESLOT,
} from 'src/pages/scheduleCallback/store/actions/app';
import {
  CREATE_INTERACTION_ERROR,
  CREATE_INTERACTION_SUCCESS,
  DELETE_INTERACTION_SUCCESS,
  LOAD_INTERACTIONS_SUCCESS,
} from 'src/pages/scheduleCallback/store/actions/interactions';
import {
  LOAD_TIMESLOTS_ERROR,
  LOAD_TIMESLOTS_SUCCESS,
} from 'src/pages/scheduleCallback/store/actions/timeslots';

export const day = (state = 0, action) => {
  switch (action.type) {
    case SET_DAY:
      return action.value.day;
    case LOAD_TIMESLOTS_SUCCESS:
      return 0;
    default:
      return state;
  }
};

export const email = (state = '', action) => {
  switch (action.type) {
    case SET_EMAIL:
      return action.value.email;
    default:
      return state;
  }
};

export const flow = (state = 'SCHEDULE_CALLBACK', action) => {
  switch (action.type) {
    case SET_FLOW:
      return action.value.flow;
    default:
      return state;
  }
};

const selectedIntentAllowlist = [
  'INTERNET',
  ACCESSIBILITY,
  BILLING,
  CANCEL_SERVICE,
  CONSENT,
  CONTACT_CDV,
  CONTACT_HSD,
  CONTACT_OTHER,
  CONTACT_VID,
  CONTACT_XH,
  DEVICE_SWAP_INTERNET,
  DEVICE_SWAP_REWARDS,
  DEVICE_SWAP_VIDEO_COMBO,
  MODIFY_SERVICE,
  NPS_FALLOUT_CDV,
  NPS_FALLOUT_VID_HSD_X1,
  NPS_FALLOUT_XH,
  OOFOOTPRINT,
  PROACTIVE_REPAIR_INGRESS,
  RETENTION,
  RETENTION_HSD_IE,
  TROUBLESHOOT_CDV,
  TROUBLESHOOT_HSD,
  TROUBLESHOOT_VID,
  WEAREONIT,
];

export const intent = (state = '', action) => {
  switch (action.type) {
    case SET_INTENT:
      if (action.value.intent === 'INTERNET') {
        return CONTACT_HSD;
      }
      if (selectedIntentAllowlist.indexOf(action.value.intent) > -1) {
        return action.value.intent;
      }
      return state;
    default:
      return state;
  }
};

export const interaction = (state = null, action) => {
  switch (action.type) {
    case CREATE_INTERACTION_ERROR:
      return null;
    case CREATE_INTERACTION_SUCCESS:
      return action.value.resource;
    case DELETE_INTERACTION_SUCCESS:
      return null;
    default:
      return state;
  }
};

export const interactions = (state = [], action) => {
  switch (action.type) {
    case LOAD_INTERACTIONS_SUCCESS:
      return action.value.resource;
    case DELETE_INTERACTION_SUCCESS:
      return [];
    default:
      return state;
  }
};

export const phone = (state = '', action) => {
  switch (action.type) {
    case SET_PHONE:
      return (action.value.phone || '').replace(/\D/g, '').slice(0, 10);
    default:
      return state;
  }
};

export const timeslot = (state = '', action) => {
  switch (action.type) {
    case SET_TIMESLOT:
      return action.value.timeslot;
    case SET_DAY:
    case LOAD_TIMESLOTS_SUCCESS:
      return '';
    default:
      return state;
  }
};

export const timeslots = (state = [], action) => {
  switch (action.type) {
    case LOAD_TIMESLOTS_SUCCESS:
      return action.value.timeslots;
    case LOAD_TIMESLOTS_ERROR:
      return [];
    default:
      return state;
  }
};

export const app = combineReducers({
  day,
  email,
  flow,
  intent,
  interaction,
  interactions,
  phone,
  timeslot,
  timeslots,
});
